module.exports = __webpack_public_path__ + "img/loan_img_2.7fb5e567.png";